import React from 'react';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './HeaderModal.css';
import {
  Modal,
  Tabs,
  Tab
} from 'react-bootstrap';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { closeHeaderModal } from '../../actions/modalActions';

// Translation
import { useIntl } from 'react-intl';

// Locale
import messages from '../../locale/jsonMessages';

import CurrencyModal from '../CurrencyModal';
import LanguageModal from '../LanguageModal';

function HeaderModal({ modalType = 'languageModal', hideCurrencyModal }) {
  const dispatch = useDispatch();
  const modalStatus = useSelector(state => state.modalStatus);
  const { formatMessage } = useIntl();

  const handleClose = () => {
    dispatch(closeHeaderModal(modalType));
  };

  return (
    <Modal
      show={modalStatus[modalType] || false}
      animation={false}
      onHide={handleClose}
      dialogClassName='commonModalContainer largeModalContainer languageModalContainer languageModalRTL'
    >
      <Modal.Header closeButton className='commonModalHeader'>
        <Modal.Title className='commonModalTitle'>{hideCurrencyModal ? formatMessage(messages.language) : formatMessage(messages.languageAndCurrency)}</Modal.Title>
      </Modal.Header>
      <Modal.Body bsClass='commonModalBody'>
        <Tabs bsStyle="pills" defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title={formatMessage(messages.chooseLanguage)}>
            <LanguageModal />
          </Tab>
          {!hideCurrencyModal && <Tab eventKey={2} title={formatMessage(messages.chooseACurrency)}>
            <CurrencyModal />
          </Tab>}
        </Tabs>
      </Modal.Body>
    </Modal>
  );
}

export default withStyles(s)(HeaderModal);
